import { render, staticRenderFns } from "./nice-users-list.vue?vue&type=template&id=9b158a76&scoped=true"
import script from "./nice-users-list.vue?vue&type=script&lang=js"
export * from "./nice-users-list.vue?vue&type=script&lang=js"
import style0 from "./nice-users-list.vue?vue&type=style&index=0&id=9b158a76&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b158a76",
  null
  
)

export default component.exports